import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

export const StyledIconButton = styled(IconButton)`
    & a {
        text-decoration: none;
        color: inherit;
    }
`;
